import { lowerFirst, transformKeys, upperFirst } from './transformKeys';

export const normalizeResponseData = <T>(data: T): T => transformKeys(data, lowerFirst);

export const normalizeRequestData = <T>(data: T): T => transformKeys(data, upperFirst);
